import { useEffect, useRef, useState } from 'react'
import { Platform } from 'react-native'

export function useInViewport<T extends Element>(rootMargin = '200px') {
    const ref = useRef<T | null>(null)
    const [visible, setVisible] = useState(Platform.OS !== 'web')

    useEffect(() => {
        if (Platform.OS !== 'web') return
        if (typeof IntersectionObserver === 'undefined') {
            setVisible(true)
            return
        }
        const node = ref.current
        if (!node) return
        const observer = new IntersectionObserver(
            entries => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        setVisible(true)
                        observer.disconnect()
                        return
                    }
                }
            },
            { rootMargin }
        )
        observer.observe(node)
        return () => observer.disconnect()
    }, [rootMargin])

    return { ref, visible }
}
